import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { fetchTaskStats } from '@/features/task/services/taskStatsService';
const sanitizeFilters = (filters) => {
    if (!filters) {
        return undefined;
    }
    const entries = Object.entries(filters).filter(([, value]) => {
        if (Array.isArray(value)) {
            return value.length > 0;
        }
        return value !== undefined && value !== null && value !== '';
    });
    if (entries.length === 0) {
        return undefined;
    }
    return Object.fromEntries(entries);
};
const useTaskStats = (filters, enabled = true) => {
    const normalizedFilters = useMemo(() => sanitizeFilters(filters), [filters]);
    const { data, error, isLoading, refetch } = useQuery(['taskStats', normalizedFilters ?? null], () => fetchTaskStats(normalizedFilters), {
        staleTime: 60000,
        enabled,
    });
    return {
        stats: data?.stats || [],
        total: data?.total ?? 0,
        loading: isLoading,
        error: error ? error.message : null,
        refetchStats: refetch,
    };
};
export default useTaskStats;
